import { Trash2 } from 'lucide-react';
import { Link } from 'react-router-dom';

import { ProtectedComponent } from '@/components/ProtectedComponent';
import { DropdownAction } from '@/components/ui/dropdown-actions';
import { DropdownMenuItem, DropdownMenuSeparator } from '@/components/ui/dropdown-menu';

import { useDeleteAgentMutation } from '@/query/agent.query';

import { Permissions } from '@/constants';

import useAlertStore from '@/store/alert.store';
import type { Agent } from '@/types/agent.type';

type Props = {
  agent: Agent;
};

export const RowAction = ({ agent }: Props) => {
  const openAlert = useAlertStore(s => s.openAlert);
  const deleteAgentMutation = useDeleteAgentMutation({
    suppressGlobalNotification: false,
  });

  const handleDelete = (e: React.MouseEvent) => {
    e.stopPropagation();
    openAlert({
      title: 'Delete Batch Call',
      description: `Are you sure you want to delete "${agent.agent_name}"? This action cannot be undone.`,
      type: 'destructive',
      confirmText: 'Delete',
      onConfirm: () => deleteAgentMutation.mutate(agent.id),
    });
  };
  return (
    <DropdownAction>
      <DropdownMenuItem asChild>
        <Link to={`/agents/${agent.canonical_name}`}>View Details</Link>
      </DropdownMenuItem>

      <ProtectedComponent requiredPermissions={[Permissions.AgentDelete]}>
        <DropdownMenuSeparator />
        <DropdownMenuItem variant="destructive" onClick={handleDelete}>
          <Trash2 className="h-4 w-4" />
          Delete
        </DropdownMenuItem>
      </ProtectedComponent>
    </DropdownAction>
  );
};
